import React from "react";
import styled from "styled-components";
import theme from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

import VladyslavTofetsky from "../../assets/SlickTeam/VladyslavTofetsky.jpg";
import VitaliiKulykImage from "../../assets/SlickTeam/VitaliiKulyk.png";
import OrestHutsulImage from "../../assets/SlickTeam/OrestHutsul.png";
import DmytroHorbanImage from "../../assets/SlickTeam/DmytroHorban.jpg";
import IgorDubokImage from "../../assets/SlickTeam/IgorDubok.png";
import YuriiKravtsovImage from "../../assets/SlickTeam/kravtsov.png";
import VitaliiKondatiukImage from "../../assets/SlickTeam/VitaliiKondatiuk.jpg";
import BohdanPasichenkoImage from "../../assets/SlickTeam/pasichenko.png";

const FoundersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
`;

const FoundersTextContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
`;

const FoundersTitle = styled.div`
  font-size: 20px;
  font-family: "Montserrat", sans-serif;sans-serif;
  font-weight: 400;
  // text-align: center;
  color: ${theme.colors.white};
`;

const FoundersLinks = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const StyledImgSection3 = styled.img`
  max-width: 150px;
  width: 100%;
  opacity: 1;
  height: 150px;
  object-fit: cover;
  border-radius: 150px;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-top: 5px;
  font-size: 20px;
  color: ${(props) => props.color};

  &:hover {
    color: ${(props) => props.hoverColor || theme.colors.white} !important;
  }
`;

export const FoundersData = [
  {
    image: VitaliiKulykImage,
    name: "Віталій Кулик",
    socialMedia: [
      {
        icon: faInstagram,
        color: theme.colors.green,
        hoverColor: "#fd5949",
        link: "https://www.instagram.com/vitalikkulyk",
      },
    ],
  },
  {
    image: YuriiKravtsovImage,
    name: "Юрій Кравцов",
    socialMedia: [
      {
        icon: faInstagram,
        color: theme.colors.green,
        hoverColor: "#fd5949",
        link: "https://www.instagram.com/yurii_kravtsov",
      },
    ],
  },
  {
    image: OrestHutsulImage,
    name: "Орест Гутцул",
    socialMedia: [
      {
        icon: faInstagram,
        color: theme.colors.green,
        hoverColor: "#fd5949",
        link: "https://www.instagram.com/oresthutsul",
      },
    ],
  },
  {
    image: DmytroHorbanImage,
    name: "Дмитро Горбань",
    socialMedia: [
      {
        icon: faInstagram,
        color: theme.colors.green,
        hoverColor: "#fd5949",
        link: "https://www.instagram.com/takeuchuha/",
      },
    ],
  },
  {
    image: BohdanPasichenkoImage,
    name: "Богдан Пасіченко",
    socialMedia: [
      {
        icon: faInstagram,
        color: theme.colors.green,
        hoverColor: "#fd5949",
        link: "https://www.instagram.com/pas1k92",
      },
    ],
  },
  {
    image: IgorDubokImage,
    name: "Ігор Дубок",
    socialMedia: [
      {
        icon: faInstagram,
        color: theme.colors.green,
        hoverColor: "#fd5949",
        link: "https://www.instagram.com/b4r0nnnnnnn/",
      },
    ],
  },
  {
    image: VladyslavTofetsky,
    name: "Владислав Тофецький",
    socialMedia: [],
  },
];

export const renderFounders = () => {
  return FoundersData.map((founder, index) => (
    <FoundersContainer key={index}>
      <StyledImgSection3 src={founder.image} />
      <FoundersTextContainer>
        <FoundersLinks>
          {founder.socialMedia.map((social, i) => (
            <a key={i} href={social.link}>
              <StyledFontAwesomeIcon
                icon={social.icon}
                color={social.color}
                hoverColor={social.hoverColor}
              />
            </a>
          ))}
        </FoundersLinks>
        <FoundersTitle>{founder.name}</FoundersTitle>
      </FoundersTextContainer>
    </FoundersContainer>
  ));
};
